module.exports = __webpack_public_path__ + "img/symbol_2.a0e1ef57.png";